
import {
  operationClosingDay,
  operationDay,
  operationMenuVisible,
  operationPath,
  operationPhase,
  visitorCode,
} from '@/utils/commercialOperation'

export default {
  name: 'CommercialOperationMenuEntry',
  props: {
    variant: {
      type: String,
      default: 'desktop',
      validator: value => ['desktop', 'mobile'].includes(value),
    },
  },
  data() {
    return {
      prefix: 'components.commercialOperationMenuEntry',
    }
  },
  computed: {
    operation() {
      return this.$store.state.commercial_operation
    },
    now() {
      return this.$store.state.clock_now
    },
    visible() {
      return operationMenuVisible(this.operation, this.now)
    },
    operationPath() {
      return operationPath(
        this.operation.slug,
        this.$i18n.locale,
        this.$i18n.defaultLocale
      )
    },
    offer() {
      return visitorCode(this.operation, {
        loggedIn: this.$auth.loggedIn,
        user: this.$auth.user,
      })
    },
    detail() {
      if (
        operationPhase(this.operation, this.now) === 'announcement' ||
        !this.offer
      ) {
        return this.$t(`${this.prefix}.announcement`, {
          day: operationDay(this.$i18n.locale, this.operation.opens_at),
        })
      }
      return this.$t(`${this.prefix}.open`, {
        value: this.offer.value,
        code: this.offer.code,
        day: operationClosingDay(this.$i18n.locale, this.operation.closes_at),
      })
    },
  },
}
